module.exports = __webpack_public_path__ + "static/media/ishita_gaikwad.1e1d42a8.png";